import * as React from "react";

const EnvelopeIcon: React.FC = () => {
    return (
        <svg width="18" height="14" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M9 10.375C8.41887 10.375 7.83773 10.1844 7.34203 9.79809L0 4.08906V12.0625C0 12.9941 0.755508 13.75 1.6875 13.75H16.3125C17.2445 13.75 18 12.9945 18 12.0625V4.08906L10.6594 9.80195C10.1637 10.1852 9.58008 10.375 9 10.375ZM0.572695 3.1082L8.03285 8.9125C8.60203 9.35547 9.39937 9.35547 9.96855 8.9125L17.4287 3.1082C17.7574 2.82695 18 2.39453 18 1.9375C18 1.00551 17.2441 0.25 16.3125 0.25H1.6875C0.755508 0.25 0 1.00551 0 1.9375C0 2.39453 0.211289 2.82695 0.572695 3.1082Z" fill="#262525"/>
        </svg>
        

    );
};

export default React.memo(EnvelopeIcon);
